import React, { useState } from 'react';
import { useSession } from '../context/SessionContext';
import Button from './Button';
import Input from './Input';
import Card from './Card';

const PasswordAuth = ({ sessionId, onSuccess }) => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const { authenticateWithPassword } = useSession();

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!password.trim()) {
      setError('Password is required');
      return;
    }

    try {
      setLoading(true);
      setError(null);
      await authenticateWithPassword(sessionId, password);
      onSuccess();
    } catch (err) {
      if (err.response?.status === 404) {
        setError('Session not found');
      } else if (err.response?.status === 401) {
        setError('Invalid password');
      } else {
        setError(err.message || 'Authentication failed');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div className="text-center">
          <h2 className="mt-6 text-3xl font-extrabold text-gray-900">
            Session Management
          </h2>
          <p className="mt-2 text-sm text-gray-600">
            Enter the password to manage this session
          </p>
        </div>
        
        <Card>
          <form onSubmit={handleSubmit} className="space-y-6">
            {error && (
              <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-md">
                {error}
              </div>
            )}
            
            <Input
              label="Management Password"
              id="password"
              name="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter session password"
              required
              autoFocus
            />
            
            <Button
              type="submit"
              fullWidth
              disabled={loading}
            >
              {loading ? 'Authenticating...' : 'Access Session Manager'}
            </Button>
          </form>
          
          <div className="mt-6 text-center">
            <p className="text-sm text-gray-600">
              Don't have the password? Contact the session creator.
            </p>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default PasswordAuth;
